import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./sessionForm.data.form";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router-dom";
import {
  InputSelect,
  BreadCrumb,
  InputDate,
  InputAutoComplete,
} from "@de-prado-dev/react-component-library";

import {
  FormContainer,
  Header,
  HeaderTitle,
  HeaderSubtitle,
  FormBody,
  FormSection,
  SectionLabel,
  ButtonsContainer,
  CancelButton,
  ActionButton,
} from "./sessionForm.styled";

const SessionForm = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    handleSubmit,
    onBack,
    edit,
    // onAddEmployee,
    // onRemoveEmployee,
    // onFilterEmployee,
    // employees,
    meetings,
    meetingSelected,
    initialValues,
  } = props;
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.session.title"), path: PATHS.LIST_SESSION },
    { label: t("forms.session.titleNew") },
  ];

  const [speakers, setSpeakers] = useState([]);
  const renderListEmployee = (item) => {
    return item;
  };

  useEffect(() => {
    if (meetings) {
      onSelectMeeting(initialValues.meetingUuid, true);
    }
  }, [meetings]);

  const onSelectMeeting = (value, isInitial = false) => {
    const meetSelected = meetings.find((m) => m.uuid === value);
    setSpeakers(meetSelected ? meetSelected.userSpeaker : []);
    if (!isInitial) {
      props.setFieldValue("speaker", "", true);
    }
  };

  return (
    <>
      {/* <div className="row justify-content-center mt-4 mt-md-5">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">
            {edit ? t("forms.session.titleEdit") : t("forms.session.titleNew")}
          </h3>
        </div>
      </div> */}
      <FormContainer>
        <Header>
          <HeaderTitle>
            {edit ? t("forms.session.titleEdit") : t("forms.session.titleNew")}
          </HeaderTitle>
          <HeaderSubtitle>
            {/* {edit
              ? t("forms.session.subtitleEdit")
              : t("forms.session.subtitle")} */}
            {/* <BreadCrumb items={breads} /> */}
          </HeaderSubtitle>
        </Header>
        <FormBody>
          <form autoComplete="off" onSubmit={handleSubmit}>
            <FormSection>
              <SectionLabel mandatory>
                {t("forms.session.labels.meetingUuid")}
              </SectionLabel>
              <Field
                id="meetingUuid"
                name="meetingUuid"
                component={InputSelect}
                placeholder=""
                optionLabel="name"
                optionValue="uuid"
                options={meetings}
                onChangeValue={(value) => {
                  onSelectMeeting(value);
                }}
                classNamePrefix="dark"
                mandatory
              />
            </FormSection>
            <div className="row mt-2">
              <div className="col-6">
                <FormSection>
                  <SectionLabel mandatory>
                    {t("forms.session.labels.speaker")}
                  </SectionLabel>
                  <Field
                    id="speaker"
                    name="speaker"
                    component={InputSelect}
                    placeholder=""
                    optionLabel="name"
                    optionValue="uuid"
                    options={speakers}
                    classNamePrefix="dark"
                    mandatory
                    addOptionEmpty
                  />
                </FormSection>
              </div>
              <div className="col-6">
                <FormSection>
                  <SectionLabel mandatory>
                    {t("forms.session.labels.date")}
                  </SectionLabel>
                  <Field
                    id="date"
                    className="form-control"
                    name="date"
                    placeholder=""
                    fieldType="text"
                    component={InputDate}
                    showTimeSelect
                    dateFormat="dd/MM/yyyy HH:mm"
                  />
                </FormSection>
              </div>
            </div>
            <ButtonsContainer>
              <CancelButton type="button" onClick={() => onBack()}>
                {t("forms.form.buttons.cancel")}
              </CancelButton>
              <ActionButton type="submit">
                {edit
                  ? t("forms.form.buttons.save")
                  : t("forms.session.titleNew")}
              </ActionButton>
            </ButtonsContainer>
          </form>
        </FormBody>
      </FormContainer>
      {/* <div className="row justify-content-center  ">
        <div className="col-12 col-md-11">
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="row mt-2">
              <div className="col-12">
                <Field
                  id="meetingUuid"
                  name="meetingUuid"
                  labelField={t("forms.session.labels.meetingUuid")}
                  component={InputSelect}
                  placeholder=""
                  optionLabel="name"
                  optionValue="uuid"
                  options={meetings}
                  onChangeValue={(value) => {
                    onSelectMeeting(value);
                  }}
                  classNamePrefix="dark"
                  mandatory
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-6">
                <Field
                  id="speaker"
                  name="speaker"
                  labelField={t("forms.session.labels.speaker")}
                  component={InputSelect}
                  placeholder=""
                  optionLabel="name"
                  optionValue="uuid"
                  options={speakers}
                  classNamePrefix="dark"
                  mandatory
                  addOptionEmpty
                />
              </div>
              <div className="col-6">
                <Field
                  id="date"
                  className="form-control"
                  labelField={t("forms.session.labels.date")}
                  name="date"
                  placeholder=""
                  fieldType="text"
                  component={InputDate}
                  showTimeSelect
                  dateFormat="dd/MM/yyyy HH:mm"
                />
              </div>
            </div> */}
      {/* <div className="row mt-2">
              <div className="col-12">
                <div className="row"> */}
      {/* <div className="col-6 d-flex flex-column">
                    <label>{t("forms.session.labels.employees")}</label>
                    <div className="input-group mb-3">
                      <Field
                        id="employees"
                        className="form-control"
                        labelField={t("forms.session.labels.filterEmployees")}
                        name="employees"
                        mandatory
                        component={InputAutoComplete}
                        fieldType="text"
                        onSearch={onFilterEmployee}
                        optionValue="uuid"
                        optionLabel="name"
                        textButtonReset={t("clear")}
                        renderItems={renderListEmployee}
                        onSelect={onAddEmployee}
                      />
                    </div>
                  </div> */}
      {/* <div className="col-6 d-flex flex-column mt-3">
                    <ListField>
                      {employees?.map((item, index) => (
                        <ItemField
                          key={`userList${index}`}
                          className="d-flex justify-content-between"
                        >
                          {item}
                          <ButtonDelete
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => onRemoveEmployee(index)}
                          >
                            <i className="fa-solid fa-xmark"></i>
                          </ButtonDelete>
                        </ItemField>
                      ))}
                    </ListField>
                  </div> */}
      {/* </div>
              </div>
            </div> */}
      {/* <div className="row justify-content-center">
              <div className="col-10 col-sm-11 text-center mt-5 mb-5">
                <button
                  type="button"
                  onClick={() => onBack(meetingSelected)}
                  className="btn btn-lg btn-secondary me-2"
                >
                  {t("forms.form.buttons.cancel")}
                </button>
                <button type="submit" className="btn btn-lg btn-primary">
                  {t("forms.form.buttons.save")}
                </button>
              </div>
            </div> */}
      {/* </form>
        </div>
      </div> */}
    </>
  );
};

SessionForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onback: PropTypes.func,
  edit: PropTypes.bool,
};

const SessionFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit, props?.meetingDates);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "SessionForm",
})(SessionForm);

export default SessionFormF;
